// extracted by mini-css-extract-plugin
export var rating = "StarRatingButton_rating__snQuz";
export var star = "StarRatingButton_star__67lOs";
export var starInput = "StarRatingButton_starInput__27IMu";